import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/HeroSection.module.scss";
import { FiPhoneCall } from "react-icons/fi";

const HeroSection = () => {
  const navigate = useNavigate();
  const formLinkHandler = () => {
    navigate("/form");
  };
  return (
    <div className={styles.heroSection}>
      <div className={styles.top}>
        <div className={styles.topHead}>
          <p className={styles.adivceText}>GET EXPERT ADVICE</p>
          <p className={styles.mainText}>
            From the UK’s no. 1 online principle bridging lender.
          </p>
        </div>

        <p className={styles.subText}>
          Simply apply online now for a fast, accurate dependable offer
        </p>
        <div className={styles.btns}>
          <p to="#" onClick={formLinkHandler} className={styles.loans}>
            Bridging Loans
          </p>
          <p to="#" onClick={formLinkHandler} className={styles.finance}>
            Development Finance
          </p>
        </div>
        <p className={styles.weekText}>Call free 7 days a week</p>

        <p className={styles.number}>
          {" "}
          <a href="tel:0207 101 33 44">
            <FiPhoneCall className={styles.phoneIcon} />
            0207 101 33 44
          </a>
        </p>
      
      </div>
    </div>
  );
};

export default HeroSection;
